<template>
    <div v-if="isMobile && visible" v-show="!dismissed" class="update-notification">
        <RowDiv>
            <SelectableButton class="small" @click="installApp">
                <div class="bu1 semi">Install App</div>
            </SelectableButton>
            <SelectableButton class="xsmall dark borderless" @click="dismiss">
                <SvgIcon name="icon/close" />
            </SelectableButton>
        </RowDiv>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            visible: false,
            dismissed: false
        };
    },
    computed: {
        ...mapState(['isMobile'])
    },
    mounted() {
        const hideInstallApp = sessionStorage.getItem('hideInstallApp');
        if (hideInstallApp) this.dismissed = true;
        this.$bus.on('pwa-prompt', this.showNotification);
    },
    methods: {
        dismiss() {
            this.dismissed = true;
            sessionStorage.setItem('hideInstallApp', 'hide');
        },
        showNotification() {
            this.visible = true;
        },
        installApp() {
            this.$bus.emit('install-pwa', true);
        }
    }
};
</script>
<style scoped>
.update-notification {
    position: fixed;
    top: 7rem;
    right: 1.5rem;
    background: var(--bg-secondary-color, #042B2F);
    color: var(--lite-gray-white, #FFFFFF);
    text-align: center;
    padding: 1rem 2rem;
    border-radius: 1rem;
    z-index: 9999999;
}
</style>